import React, { Fragment } from "react";
import Breadcrumbs from "../../CommonElements/Breadcrumbs";
import Profile from "../../Component/Profile/profile";

const ProfileContain = () => {
  return (
    <Fragment>
      {/* <Breadcrumbs parent="Tasks" title="Manage Tasks" /> */}
      <Profile />
    </Fragment>
  );
};
export default ProfileContain;
